import { goSolidApi } from "@/composables/useGoSolidApi";
import type {
  CancellationRuleEvaluationRequest,
  CancellationRuleEvaluationResponse,
} from "@/dashboard/inventory_management/cancel/cancellationRulesTypes";
import type { CancellationRegistryOptionsResponse } from "@/dashboard/inventory_management/common/cancellationTargetTypes";

/** The backend's cancellation rules (DEV-626): the frontend keeps no copy of them. */
export const cancellationRulesApi = {
  /** `GET /api/portfolio/cancel/registry-options`: every cancellation target region and the "Any AIB" entry. Not company-specific. */
  getRegistryOptions: () =>
    goSolidApi.get<CancellationRegistryOptionsResponse>(
      "/api/portfolio/cancel/registry-options"
    ),

  /**
   * `POST /api/company/:companyId/portfolio/cancel/rule-evaluation`: the warnings a draft matches. Read-only;
   * incomplete statements are evaluated as far as they go. The response has one entry per request statement, in order.
   */
  evaluate: (companyId: number, request: CancellationRuleEvaluationRequest) =>
    goSolidApi.post<CancellationRuleEvaluationResponse>(
      `/api/company/${companyId}/portfolio/cancel/rule-evaluation`,
      request
    ),
};
